@if (showLoadingComponent()) {
  <ng-container *ngComponentOutlet="loader; inputs: { title: title, isLoading: isLoading() }" />
}
<router-outlet></router-outlet>